import { TStore } from "redux/reducer";

export const selectCatalogState = (state: TStore) => state.catalog;
